import { render, staticRenderFns } from "./HourseCharge.vue?vue&type=template&id=991c71b4&scoped=true"
import script from "./HourseCharge.vue?vue&type=script&lang=js"
export * from "./HourseCharge.vue?vue&type=script&lang=js"
import style0 from "./HourseCharge.vue?vue&type=style&index=0&id=991c71b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c71b4",
  null
  
)

export default component.exports